import { useQuery } from '@apollo/client'
import { Typography } from '@mui/material'
import { useEffect, useRef } from 'react'
import Loader from '../components/Loader'
import { UserProfileDocument } from '../graphql/generated'
import { modalVar } from '../providers/apollo/cache'
import useLoginFirebase from './auth/hooks/useLogin'

export default function RestoreSession() {
  const { data } = useQuery(UserProfileDocument)
  const { attemptRedirect } = useLoginFirebase()
  const attemptRedirectRef = useRef(attemptRedirect)

  useEffect(() => {
    if (!data) return
    const latestTermsAccepted = data.userProfile?.latestTermsAccepted ?? false

    if (!latestTermsAccepted) {
      modalVar('termsAndConditions')
      return
    }

    attemptRedirectRef.current()
  }, [data])

  return (
    <div style={{ padding: '20px', textAlign: 'center', minHeight: '80vh', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <div style={{ height: '100px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Loader />
      </div>
      <Typography variant="h4" style={{ fontWeight: '700' }}>
        Restoring your session...
      </Typography>
    </div>
  )
}
